export default class AdjuntosClass {
    public Id: number
    public OrdenLocalId: number
    public FileName: string
    public LocalId: number
    public AdjuntoData: string
    public SHA256: string
    public Categoria: string
    public Borrado: boolean
}
